module.exports = __webpack_public_path__ + "img/banner.accdbf82.png";